var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "i-search" },
    [
      _c(
        "search-select",
        {
          attrs: {
            placeholder: _vm.$t("searchContent"),
            value: _vm.searchKeywords,
            options: _vm.combineSearchResult,
            "option-format": { valueKey: "name", textKey: "name" },
            "icon-behavior": "submit",
            type: "searchKeywords",
          },
          on: {
            input: _vm.onInput,
            submit: _vm.onSubmit,
            select: _vm.onSubmit,
          },
          model: {
            value: _vm.inputValue,
            callback: function ($$v) {
              _vm.inputValue = $$v
            },
            expression: "inputValue",
          },
        },
        [
          _c("svg-icon", {
            staticClass: "icon",
            attrs: { slot: "icon", name: "search", color: "#EC0A74" },
            on: {
              click: function ($event) {
                _vm.isTaiwantrade ? _vm.onSubmit : null
              },
            },
            slot: "icon",
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }